import { Fragment } from "react";
import { Container, createStyles, Grid, makeStyles, Paper, Theme, Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import { ProfileSelectionForm } from "../../authentication/components/ProfileSelectionForm";
import { useProfilesSelectorController } from "../hooks/useProfilesSelectorController";
import LoadingIndicator from "../../../components/Shared/LoadingIndicator";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
        },
        paper: {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
            position: 'relative' // the loading spinner refers to this element
        },
        content: {
            marginBottom: theme.spacing(2)
        }
    })
);

export const ProfilesPage = observer(() => {

    /********* React hooks *********/

    const classes = useStyles();
    const controller = useProfilesSelectorController();

    /********* Render *********/

    return (
        <Fragment>
            {controller.values.isLoading
                ? <LoadingIndicator />
                : <Container className={classes.root}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Paper className={classes.paper}>
                                <Container>
                                    <div className={classes.content}>
                                        <Typography variant="h4">Profiles</Typography>
                                        <ProfileSelectionForm
                                            values={controller.values}
                                            onChange={controller.onChange}
                                            onSubmit={controller.onSubmit}
                                            isSubmitting={controller.isSubmitting}
                                            error={controller.error}
                                            fieldErrors={controller.fieldErrors}
                                        />
                                    </div>
                                </Container>
                            </Paper>
                        </Grid>
                    </Grid>
                </Container>
            }
        </Fragment >
    );
});
